<template>
  
    <div class="font-outfit ">
  
      <div class="my-7 flex justify-center cursor-pointer">
        <router-link to="/"><img src="../assets/images/medremindLogo.png" alt="logo" class="mr-3 sm:h-8"></router-link>
      </div>
  
      <div>
        <h1  class="text-black text-2xl font-semibold font-outfit my-2"  > Reset Password</h1>
      </div>
  
      
      <div
        v-if="success"
        class=" border w-2/6 mx-auto bg-medalertBlue bg-opacity-10    text-black px-4 py-3 mt-4 rounded relative"
        role="alert">
  
        <span class="">{{ success }}</span>
        <strong class="font-bold mx-2"><router-link to="/login" >Login Now</router-link></strong>
        </div>
  
        <div
        v-if="error"
        class=" border w-2/6  mx-auto bg-red  text-white px-4 py-3 mt-4 rounded relative"
        role="alert">
  
            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
            <span class="">{{ error }}</span>
        </div>
  
  
  
      <div class="bg-white text-black px-20 py-8 font-outfit flex flex-col justify-center mx-auto align-middle    content-center w-2/4">
      
  
          <form class="w-full" @submit.prevent="handleUpdateRequest">
  
              
              <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <div class="flex justify-between mb-3">
                  <label class="font-semibold text-base " for="">Enter new password</label>
                  <div class="cursor-pointer text-xs font-semibold font-outfit">
                    <span  @click="showPassword = !showPassword">  <p v-if="showPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                  </div>
                </div>
                  <input
                  v-bind:type="[showPassword ? 'text' : 'password']"
                   v-model="password" required type="password"  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                  bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Password " >
              </div>
  
  
              <div class="mt-10 mx-11">
                  <button
                   :class="inactive ? 'cursor-not-allowed' : ''"
                   :disabled="inactive" type="submit" class="text-white disabled:bg-gray-200 bg-medalertBlue  hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple font-outfit">Reset Password
                  <!-- <span v-if="isLoading">
                    <Loading />
                  </span> -->
                  </button>
              </div>
          </form>
  
      </div>
  
    </div>
  
  </template>
  
  
  
  <script>
  
  import { ref } from 'vue'
  import Loading from "../components/Loading";
  import {useStore} from 'vuex'
  import {useRouter} from 'vue-router'
  import { useRoute } from "vue-router";
  import axios from 'axios';
  
  export default {
  
      components:{Loading},
  
      data(){
          return{
              showPassword:false
          }
      },
  
      setup() {

      const store = useStore()
      const route = useRoute();
      const router = useRouter()

      const password = ref('')
      const error =ref('')
      const isLoading = ref(false);
      const success = ref('');

      const inactive = ref(false);
      const showPassword = ref(false);

      const resetToken = route.params.token;
      console.log(resetToken)
  
      
      const handleUpdateRequest = async () => {
        try {
          inactive.value = true
        
          axios.defaults.headers.common['Authorization'] = "Bearer " + resetToken

          const response = await axios.put(`/api/v1/account/update-password?new-password=${password.value}`)

          if (response){

          success.value = response.data.result.message ;

          (password.value = '')


          setTimeout(() => {
          // success.value = '';
          inactive.value = false
          router.push("/login");
          }, 3000);

          store.commit("setUser", null);
          store.commit("saveToken", null);
          window.localStorage.user = JSON.stringify(null);
          window.localStorage.token = JSON.stringify(null);

          }   
               
        } catch(err) {
          error.value = err.message
  
          setTimeout(() => {
            inactive.value = false
            error.value = '';
          }, 3000);
        }
  
      }
  
  
      return { 
      password,  
      error, 
      success,
      isLoading,
      resetToken,
      inactive,
      showPassword,
      handleUpdateRequest }
    }
  
  }
  
  </script>
  
  
  
  <style>
  
  </style>